module.exports = __webpack_public_path__ + "static/media/classroom1.59977b33.glb";